import React from 'react'

const Textarea = props => {
    return (
        <div>
            <label className={`text-sm block mb-1 ${props.labelColor === "black" ? "text-black" : "text-primary"}`}>{props.label}</label>
            <textarea className={`w-full placeholder-opacity-50 bg-opacity-20 placeholder-primary px-4 py-2.5 leading-snug text-sm ${props.hasError ? "border-secondary focus:ring-secondary" : "border-transparent  focus:ring-primary"} border  rounded-md bg-primary focus:outline-none focus:ring-1`} rows="5" placeholder={props.placeholder} {...props}>{props.value}</textarea>
            <span class="text-xs text-red-700">{props.error}</span>
        </div>
    )
}

export default Textarea
